import { Box } from "@mui/material";
import type { FC } from "react";

export const GradientSvg: FC<{
  viewBox: string;
  children: React.ReactNode;
  gradientId?: string;
  width?: number | string;
  height?: number | string;
  startColor?: string;
  endColor?: string;
}> = ({
  viewBox,
  children,
  gradientId = "gradient",
  width = 24,
  height = 24,
  startColor = "#00B6EF",
  endColor = "#C24599",
}) => {
  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={startColor} />
          <stop offset="100%" stopColor={endColor} />
        </linearGradient>
      </defs>
      {children}
    </Box>
  );
};
